import React from 'react'
import { Tabs, Tab, Row, Col } from '@themesberg/react-bootstrap'
import useProfilePage from './useProfilePage'
import { adminConfigConstants, permissionLabel, profileConstants, profileConstantsTA, siteConfigConstants, socialMediaConfigConstants } from './constants'
import Preloader from '../Preloader'
import Hierarchy from '../Hierarchy'
import Overview from './Overview'
import Permission from './Permission'
import Credentials from './Credentials'
import Password from './Password'
import SiteConfig from './SiteConfig'
import AdminConfig from './AdminConfig'
import BonusConfig from './AdminBonusConfig'
import ApkConfig from './ApkConfig'
import NotificationIcon from '../NotificationIcon'
import { useNavigate } from 'react-router-dom'
import { AdminsRoutes } from "../../routes"
import useCheckPermission from '../../utils/checkPermission'


export default ({ isTenant }) => {
  const {
    details,
    selectedTab,
    setSelectedTab,
    editable,
    setEditable,
    updateData,
    updateSiteConfiguration,
    updateAdminConfiguration,
    loading,
    adminDetails,
    updateCredentials,
    editableCreds,
    setEditableCreds,
    resetPassLoading,
    isGetLoading,
    editableSiteConfig,
    setEditableSiteConfig,
    editableAdminConfig,
    setEditableAdminConfig,
    isSiteConfigurationsEdit
  } = useProfilePage(isTenant)

  const constant = profileConstants
  const siteConstant = siteConfigConstants
  const adminConstants = adminConfigConstants
  const navigate = useNavigate()
  const { isSuperAdmin , isHidden } = useCheckPermission()

  const isSiteConfigurations   = isHidden({ module: { key: 'SiteConfiguration', value: 'R' } })

  return (
    <>
      {loading
        ? <Preloader />
        : (
          <>
            <div className='section-header-wrap mt-n3 mx-n3'>
              <Row className="align-items-center">
                <Col lg={6} xs={6}>
                  <h2 className="title-text">Profile</h2>
                </Col>

                <Col lg={6} xs={6} className="text-end">
                  <NotificationIcon />
                </Col>

              </Row>
            </div>

            <Tabs
              activeKey={selectedTab}
              onSelect={(tab) => {
                setEditable(false)
                setEditableCreds(false)
                navigate(`${AdminsRoutes.Profile}?tab=${tab}`)
                // setSelectedTab(tab)
              }}
              mountOnEnter
              unmountOnExit
              className='nav-light'
            >
              <Tab eventKey='overview' title='Overview'>
                <div className='mt-3'>
                  <Overview
                    details={details}
                    isTenant={isTenant}
                    setEditable={setEditable}
                    editable={editable}
                    updateData={updateData}
                    constant={constant}
                    loading={loading}
                    isGetLoading={isGetLoading}
                  />
                </div>
              </Tab>

              {!isSiteConfigurations && <Tab eventKey='SiteConfiguration' title='Site Configuration'>
                <div className='mt-3'>
                  <SiteConfig
                    isTenant={isTenant}
                    setEditable={setEditableSiteConfig}
                    editable={editableSiteConfig}
                    updateData={updateSiteConfiguration}
                    constant={siteConstant}
                    loading={loading}
                    isSiteConfigurationsEdit={isSiteConfigurationsEdit}
                  />
                </div>
              </Tab>}

              {adminDetails?.adminRoleId === 1 && <Tab eventKey='apkConfiguration' title='Apk Configuration'>
                <div className='mt-3'>
                  <ApkConfig

                  />
                </div>
              </Tab>}

              <Tab eventKey='password' title='Reset Password'>
                <div className='mt-3'>
                  <Password
                    isTenant={isTenant}
                    loading={resetPassLoading}
                  />
                </div>
              </Tab>

              {adminDetails?.superRoleId === 1 &&
                <Tab eventKey='credentials' title='Credentials'>
                  <div className='mt-3'>
                    <Credentials
                      details={details}
                      updateCreds={updateCredentials}
                      loading={loading}
                      editableCreds={editableCreds}
                      setEditableCreds={setEditableCreds}
                    />
                  </div>
                </Tab>}

              <Tab eventKey='permissions' title='Permissions'>
                <div className='mt-3'>
                  <Permission details={details} permissionLabel={permissionLabel} />
                </div>
              </Tab>

              {isSuperAdmin() && <Tab eventKey='adminConfiguration' title='Admin Configuration'>
                <div className='mt-3'>

                  <AdminConfig
                    isTenant={isTenant}
                    setEditable={setEditableAdminConfig}
                    editable={editableAdminConfig}
                    updateData={updateAdminConfiguration}
                    constant={adminConstants}
                    loading={loading}
                    title="General Admin Configurations"
                  />

                </div>
                {isSuperAdmin() ? <div className='mt-3'>
                  <BonusConfig updateData={updateAdminConfiguration} title="Sports Book Admin Configurations" />

                </div>



                  : ""}

                {isSuperAdmin() ? <div className='mt-3'>
                  <AdminConfig
                    isTenant={isTenant}
                    setEditable={setEditableAdminConfig}
                    editable={editableAdminConfig}
                    updateData={updateAdminConfiguration}
                    constant={socialMediaConfigConstants}
                    loading={loading}
                    isSocial={true}
                    title="Social Media Admin Configurations"
                  />

                </div> : ""}
              </Tab>}

              {/* {!isTenant &&
                <Tab eventKey='usersTree' title='Tree'>
                  <div className='mt-3'>
                    <Row className='mt-3 d-flex flex-row-reverse text-right'>
                      {details && details?.adminUserId && (
                        <Hierarchy
                          isTenant={isTenant}
                          adminDetails={{
                            name: `${details?.firstName} ${details?.lastName}`,
                            id: details?.adminUserId,
                            children: [],
                            isInitial: true,
                            data: { superRoleId: details?.adminRoleId }
                          }}
                        />
                      )}
                    </Row>
                  </div>
                </Tab>} */}
            </Tabs>
          </>)}
    </>
  )
}
